<template>
  <div class="leave-calendar">
    <Row class="head" type="flex" align="middle" justify="space-between">
      <!-- 日期切换-start -->
      <div class="calendar-switch">
        <div class="calendar-switch-btn" @click="onChangeMonth('prev')">
          <Icon
            class="dashboard-calendar-icon calendar-icon calendar-perv-icon"
            type="ios-arrow-back"
          />
        </div>
        <span class="date-picker-text">
          {{ calendarDate }}
        </span>
        <div class="calendar-switch-btn" @click="onChangeMonth('next')">
          <Icon
            class="dashboard-calendar-icon calendar-icon"
            type="ios-arrow-forward"
          />
        </div>
      </div>
      <!-- 日期切换-end -->
      <Row type="flex" align="middle">
        <i-switch v-model="viewLeave" @on-change="onViewLeaveChange" />
        <span class="switch-text">{{ $t('global.leaveSwitch') }}</span>
      </Row>
    </Row>
    <ul class="calendar-box">
      <li class="item week-box">
        <span class="week" v-for="(item, index) in weeks" :key="index">
          {{ item }}
        </span>
      </li>
      <li class="item" v-for="(item, index) in row" :key="index">
        <div
          class="day-box"
          :class="subItem.class"
          v-for="subItem in item"
          :key="subItem.day"
          @click="onOpenDrawer(subItem)"
        >
          <div class="day-body">
            <p class="day" :class="{ 'cur-day': subItem.curDay }">
              {{ subItem.text }}
            </p>
            <Tooltip
              class="holiday"
              placement="right"
              max-width="450"
              transfer
              transfer-class-name="calendar-tooltip"
              v-if="subItem.isHoliday"
            >
              <div class="leave-time" slot="content">
                <p>{{ subItem.holidayTips }}：</p>
                <p>{{ subItem.holidayName }}</p>
              </div>
              {{ subItem.holidayName }}
            </Tooltip>
            <div class="leave-box" v-if="subItem.leaveRecords.length">
              <div
                class="leave"
                :class="{ 'leave-and-holiday': subItem.isHoliday }"
                v-for="(leave, index) in subItem.leaveRecords"
                :key="leave.id"
                v-show="index < setQuantity(subItem.isHoliday)"
              >
                <Tooltip
                  class="leave-tooltip"
                  placement="right"
                  max-width="450"
                  transfer
                  transfer-class-name="calendar-tooltip"
                >
                  <div class="leave-time" slot="content">
                    <p>{{ leave.displayName }}：{{ leave.leaveTypeName }}</p>
                    <p>
                      {{ $t('global.leaveTime') }}：{{
                        formatTime(leave.startedAt)
                      }}
                      - {{ formatTime(leave.endedAt) }}
                    </p>
                    <p>
                      {{ $t('apply.duration') }}：{{ leave.totalMinutes
                      }}{{ $t(`global.${leave.timeUnit}`) }}
                    </p>
                  </div>
                  {{ leave.displayName }}：{{ leave.leaveTypeName }}
                </Tooltip>
              </div>
              <!-- 非hover状态-start -->
              <p
                class="leave-remain-box leave-remain-normal"
                v-show="
                  subItem.leaveRecords.length > setQuantity(subItem.isHoliday)
                "
              >
                <span class="leave-remain">
                  +{{
                    subItem.leaveRecords.length - setQuantity(subItem.isHoliday)
                  }}
                </span>
              </p>
              <!-- 非hover状态-end -->
              <!-- hover状态-start -->
              <p
                class="leave-remain-box leave-remain-hover"
                v-show="
                  subItem.leaveRecords.length >
                  setQuantity(subItem.isHoliday, true)
                "
              >
                <span class="leave-remain">
                  +{{
                    subItem.leaveRecords.length -
                    setQuantity(subItem.isHoliday, true)
                  }}
                </span>
              </p>
              <!-- hover状态-end -->
            </div>
          </div>
        </div>
      </li>
    </ul>
    <Drawer
      class-name="calendar-leave-drawer"
      :title="drawerTitle"
      placement="right"
      width="320"
      :mask="false"
      v-model="isDrawer"
    >
      <template v-if="curDayData">
        <p class="statistics">
          {{
            [curDayData.leaveRecords.length, $t('global.leaveDrawerTitle')]
              | space
          }}
        </p>
        <ul class="list">
          <li
            class="item"
            v-for="item in curDayData.leaveRecords"
            :key="item.id"
          >
            <Row class="user" type="flex" :wrap="false">
              <div class="avatar-box">
                <Avatar class="avatar" :src="item.avatar" v-if="item.avatar" />
                <Avatar class="avatar default-avatar" v-else>
                  {{ $substrName(item.displayName, 2) }}
                </Avatar>
              </div>
              <div class="text-box">
                <p class="name-number">
                  <span class="name">{{ item.displayName }}</span>
                  <span class="number">#{{ item.employeeNumber }}</span>
                </p>
                <div class="status-tag" v-if="item.formStatus">
                  {{ $t('calendar.pending') }}
                </div>
                <p class="dep-job">
                  <span class="job">
                    {{ $_.truncate(item.jobTitle, { length: 20 }) }}
                  </span>
                  <Divider type="vertical" />
                  <span class="dep">
                    {{ $_.truncate(item.departmentName, { length: 20 }) }}
                  </span>
                </p>
              </div>
            </Row>
            <div class="leave-box">
              <Row type="flex" :wrap="false">
                <div class="leave-item-label-box">
                  <p class="leave-item-label">{{ $t('global.leaveType') }}：</p>
                  <p class="leave-item-label">{{ $t('global.leaveTime') }}：</p>
                  <p class="leave-item-label">{{ $t('apply.duration') }}：</p>
                </div>
                <div class="leave-item-value-box">
                  <p class="leave-item-value">
                    {{ item.leaveTypeName }}
                  </p>
                  <p class="leave-item-value">
                    {{ formatTime(item.startedAt) }}
                    - {{ formatTime(item.endedAt) }}
                  </p>
                  <p class="leave-item-value">
                    {{
                      [item.totalMinutes, $t(`global.${item.timeUnit}`)] | space
                    }}
                  </p>
                </div>
              </Row>
            </div>
          </li>
        </ul>
        <div class="btn-box">
          <Button
            icon="ios-download-outline"
            type="primary"
            ghost
            @click="onLeaveRecordExport(curDayData.day)"
          >
            {{ $t('calendar.export') }}
          </Button>
        </div>
      </template>
    </Drawer>
    <OaExportPercent ref="oaExportPercent" />
  </div>
</template>
<script>
import OaExportPercent from '@/components/oa_export_percent';
export default {
  data() {
    this.weeks = [
      this.$t('global.s'),
      this.$t('global.M'),
      this.$t('global.T'),
      this.$t('global.W'),
      this.$t('global.t'),
      this.$t('global.F'),
      this.$t('global.S')
    ];
    this.initRowData = {};
    this.data = [];
    return {
      viewMyLeave: false, // 只查看我的请假
      curMonth: this.$moment().format('YYYY-MM'),
      filters: {
        search: null
      },
      loading: false,
      row: {},
      holidays: [],
      calendars: [],
      isDrawer: false,
      drawerTitle: '',
      curDayData: null,
      viewLeave: false
    };
  },
  components: {
    OaExportPercent
  },
  filters: {
    /**
     * 多语言，文字連接
     * @param { string[] } list: 文本列表
     * @param { object } map: 词语间的分隔字符
     * @param { unknown } def: 默认分隔字符
     */
    space(list = [], map = { en: ' ' }, def = '') {
      const vm = document.getElementById('app').__vue__;
      if (vm && vm.$i18n) return list.join(map[vm.$i18n.locale] || def);
      else return def;
    }
  },
  computed: {
    calendarDate() {
      const reg = /\b(0+)/gi; // 去除0
      const year = this.curMonth.substr(0, 4).replace(reg, '');
      const month = this.curMonth.substr(-2).replace(reg, '');
      const enMonth = this.$t(`i.datepicker.months.m${month}`);
      const enText = `${enMonth} ${year}`;
      const cnText = `${year}${this.$t('global.YEARLY')}${month}${this.$t(
        'global.MONTHLY'
      )}`;
      return this.$i18n.locale === 'en' ? enText : cnText;
    }
  },
  mounted() {
    this.getLeaveData();
  },
  methods: {
    // 切换日历月份
    onChangeMonth(type) {
      if (type === 'next') {
        this.curMonth = this.$moment(this.curMonth)
          .add(1, 'M')
          .format('YYYY-MM');
      }
      if (type === 'prev') {
        this.curMonth = this.$moment(this.curMonth)
          .subtract(1, 'M')
          .format('YYYY-MM');
      }
      this.getLeaveData();
    },
    // 是否显示请假信息
    onViewLeaveChange() {
      if (this.viewLeave) {
        _.forEach(this.row, (r) => {
          _.forEach(r, (item) => {
            item.leaveRecords = _.filter(
              item.leaveRecords,
              (f) => f.employeeId === this.$store.state.self.id
            );
          });
        });
      } else {
        this.row = _.cloneDeep(this.initRowData);
      }
    },
    async getLeaveData() {
      try {
        this.loading = true;
        const res = await this.$http(
          'get',
          `mobile/leave_records/calendar/${this.$moment(this.curMonth).format(
            'YYYY/MM'
          )}`,
          this.filters,
          true,
          'attendance'
        );
        this.data = res.data;
        await this.initHolidays();
        this.initCalendars();
        this.onViewLeaveChange();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    // 初始化日历
    initCalendars() {
      this.calendars = [];
      const curDay = this.$moment().format('YYYY-MM-DD');
      for (let i = 0; i < 42; i++) {
        const startDate = this.$moment(this.curMonth).date(1); // 当月第一天
        const day = startDate.weekday(i).format('YYYY-MM-DD');
        const dateItem = _.find(this.data, (v) => v.workingDate === day);
        const leaveRecords = dateItem ? dateItem.leaveRecords : [];
        const calendar = {
          text: this.$moment(day).format('DD'),
          day: day,
          curDay: day === curDay,
          holidayName: null,
          isHoliday: false,
          leaveRecords: leaveRecords
        };
        let name = null;
        let holidayTips = null;
        _.forEach(this.holidays, (v) => {
          if (
            day === v.startedDate ||
            day === v.endedDate ||
            this.$moment(day).isBetween(v.startedDate, v.endedDate) === true
          ) {
            this.$set(calendar, 'isHoliday', true);
            // 设置节假日说明
            if (!name) {
              name = v.name;
            } else {
              if (name !== v.name && holidayTips === v.holidayGroupName) {
                name = name + '、' + v.name;
              }
            }
            if (holidayTips && holidayTips !== v.holidayGroupName) {
              holidayTips = `${v.holidayGroupName} & ${holidayTips}`;
            } else {
              holidayTips = v.holidayGroupName;
            }
            this.$set(calendar, 'holidayName', v.name);
            this.$set(calendar, 'holidayTips', holidayTips);
          }
        });
        this.calendars.push(calendar);
      }
      this.initRow();
    },
    initRow() {
      const row = {
        days1: [],
        days2: [],
        days3: [],
        days4: [],
        days5: [],
        days6: []
      };
      _.forEach(this.calendars, (v, i) => {
        let key = 6;
        if (i <= 6) {
          key = 1;
        } else if (i <= 13) {
          key = 2;
        } else if (i <= 20) {
          key = 3;
        } else if (i <= 27) {
          key = 4;
        } else if (i <= 34) {
          key = 5;
        }
        if (this.$moment(v.day).format('YYYY-MM') !== this.curMonth) {
          v.class = 'not-this-month';
        }
        row[`days${key}`].push(v);
      });
      if (
        !_.some(
          row.days6,
          (s) => this.$moment(s.day).format('YYYY-MM') === this.curMonth
        )
      ) {
        // 最后一行没有当月，则删除
        delete row.days6;
      }
      this.initRowData = row;
      this.row = _.cloneDeep(this.initRowData);
    },
    // 获取节假日数据
    async initHolidays() {
      const res = await this.$http(
        'get',
        `manager/attendance_summary/work_calendar/${this.$moment(
          this.curMonth
        ).format('YYYY/MM')}`,
        {},
        true,
        'attendance'
      );
      this.holidays = res.data.holidays;
    },
    // 格式化请假时间
    formatTime(time) {
      return this.$moment(`${time}Z`).format('DD/MM/YYYY HH:mm');
    },
    // 设置假期显示数量等
    setQuantity(e, hover) {
      let n = e ? 1 : 2;
      return hover ? n + 1 : n;
    },
    // 请假列表抽屉
    onOpenDrawer(e) {
      if (e.leaveRecords.length) {
        const reg = /\b(0+)/gi; // 去除0
        const year = this.curMonth.substr(0, 4).replace(reg, '');
        const month = this.curMonth.substr(-2).replace(reg, '');
        const day = e.text.replace(reg, '');
        const enMonth = this.$t(`i.datepicker.months.m${month}`);
        const enText = `${day} ${enMonth} ${year}`;
        const cnText = `${year}${this.$t('global.YEARLY')}${month}${this.$t(
          'global.MONTHLY'
        )}${day}${this.$t('global.s')}`;
        this.drawerTitle = this.$i18n.locale === 'en' ? enText : cnText;
        this.curDayData = e;
        this.isDrawer = true;
      }
    },
    // 导出所选天数请假记录
    onLeaveRecordExport(date) {
      const fileName = `${date}${this.$t('calendar.leaveRecords')}`;
      this.$refs.oaExportPercent.export_template(
        'mobile/leave_records/export/all',
        {
          startDate: date,
          endDate: date,
          calenderFlag: true
        },
        fileName,
        'excel',
        'get',
        'attendance'
      );
    }
  }
};
</script>
<style lang="less" scoped>
ul,
li {
  list-style: none;
}

.head {
  height: 24px;
  margin-bottom: 40px;
}

.calendar-switch {
  display: flex;
  align-items: center;

  .calendar-switch-btn {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #f2f3f5;
    cursor: pointer;
  }

  .calendar-icon {
    font-size: 24px;
    color: #858d99;
  }

  .date-picker-text {
    font-size: 24px;
    font-weight: bold;
    line-height: 24px;
    margin: 0 16px;
  }
}

.switch-text {
  margin-left: 16px;
}

.calendar-box {
  .item {
    display: grid;
    grid-template-columns: repeat(7, calc(100% / 7));
    text-align: center;

    &:not(:last-child) {
      border-bottom: 1px solid #e5e6eb;
    }
  }

  .week-box {
    padding: 10px 0;
    border-bottom: 1px solid #e5e6eb;

    .week {
      flex: 1;
      font-size: 14px;
      color: #4e5969;
    }
  }

  .day-box {
    font-size: 16px;
    height: 131px;
    cursor: pointer;
    position: relative;

    .day-body {
      height: 100%;
      background-color: #fff;
      padding: 4px 4px 0 4px;
      overflow: hidden;

      &:hover {
        padding: 8px;
        border-radius: 4px;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 10;
        transform: translate(-50%, -50%);
        width: 101%;
        height: 204px;
        box-shadow: 0px 0px 10px -5px rgba(0, 0, 0, 0.04),
          0px 0px 25px -5px rgba(0, 0, 0, 0.1);
        transition: width 0.2s ease, height 0.2s ease;
        opacity: 1;

        .leave:nth-child(3) {
          display: block !important;
        }

        .leave-and-holiday:nth-child(2) {
          display: block !important;
        }

        .leave.leave-and-holiday:nth-child(3) {
          display: none !important;
        }

        .leave-remain-normal {
          display: none;
        }

        .leave-remain-hover {
          display: inline-block;
        }
      }
    }

    .day {
      width: 32px;
      line-height: 32px;
      margin: 0 auto 4px auto;
    }

    .cur-day {
      color: #fff;
      border-radius: 50%;
      background-color: #5fc5ce;
    }

    .leave-box,
    .leave-remain-box {
      text-align: left;
    }

    .holiday,
    .leave-tooltip,
    .leave-remain-box {
      height: 28px;
      line-height: 20px;
      max-width: 100%;
      font-size: 12px;
      font-weight: bold;
    }

    .holiday,
    .leave-tooltip {
      padding: 4px;
      border-radius: 2px;

      /deep/.ivu-tooltip-rel {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .holiday {
      color: #a1151e;
      background-color: #ffece8;
      margin-bottom: 4px;
    }

    .leave-tooltip,
    .leave-remain {
      color: #a57420;
      background-color: #fffce8;
    }

    .leave {
      height: 28px;

      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }

    .leave-remain {
      display: inline-block;
      padding: 4px;
      border-radius: 2px;
    }

    .leave-remain-hover {
      display: none;
    }
  }

  .not-this-month .day-body {
    opacity: 0.4;
  }
}

.calendar-leave-drawer {
  .statistics {
    flex-shrink: 0;
    padding: 0 16px;
    font-size: 12px;
  }

  .list {
    flex: 1;
    overflow-y: auto;
    padding: 20px 16px 16px 16px;

    .item:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  .user {
    line-height: 20px;
  }

  .avatar-box {
    width: 40px;
    height: 40px;
    margin: 0 12px 9px 0;
  }

  .avatar {
    width: 40px;
    height: 40px;
    line-height: 40px;
    background-color: #e8fffe;
    color: #207a8e;
  }

  .text-box {
    flex: 1;
    position: relative;
  }

  .status-tag {
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    border-radius: 4px;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 12px;
    color: #9e3d14;
    background-color: #fff4e8;
  }

  .name-number {
    max-width: 180px;
  }

  .name {
    font-weight: bold;
    font-size: 14px;
  }

  .number {
    font-size: 12px;
    font-weight: normal;
    margin-left: 4px;
  }

  .dep-job {
    font-size: 12px;
    margin-top: 4px;
  }

  .ivu-divider {
    height: 14px;
    margin: 0 4px;
    background-color: #272e3b;
  }

  .leave-box {
    margin-top: 9px;
    line-height: 20px;
    color: #6b7785;
    font-size: 12px;

    .leave-item-label-box {
      flex-shrink: 0;
    }

    .leave-item-value-box {
      flex: 1;
      width: 0;
    }

    .leave-item-value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .text-box {
    flex: 1;

    .name {
      margin: 2px 0 4px 0;
      line-height: 14px;
    }
  }

  .btn-box {
    flex-shrink: 0;
    border-top: 1px solid #e5e6eb;
    padding: 12px 16px;

    .ivu-btn {
      width: 100%;
      height: 32px;
      font-size: 14px;
      line-height: 32px;
    }
  }
}
</style>
<style lang="less">
.calendar-tooltip {
  .ivu-tooltip-inner-with-width {
    white-space: normal;

    .leave-time {
      line-height: 20px;
    }
  }
}

.calendar-leave-drawer {
  .ivu-drawer-content {
    display: flex;
    flex-direction: column;
  }

  .ivu-drawer-header {
    flex-shrink: 0;
  }

  .ivu-drawer-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 16px 0 0 0;
    position: static;
  }
}
</style>
